import script from "./hotTag.vue?vue&type=script&setup=true&lang=js"
export * from "./hotTag.vue?vue&type=script&setup=true&lang=js"

import "./hotTag.vue?vue&type=style&index=0&id=c4f89a60&lang=css"

const __exports__ = script;

export default __exports__